import {
  addressAgent,
  agentJSONConfig,
  channelJSONConfigAgent,
  channelsJSONConfigAgent,
  ctAgent,
  myAccountAgent,
  orderAgent,
  prequalAgent,
  serviceProviderAgent,
  staticJsonConfigAgent,
  technicianDetailsAgent,
  usersDetailsAgent,
  voiceAgent,
} from '@/lib/agents';
import { APP_ENVIRONMENT, SENTRY_DENY_URLS, SENTRY_DSN } from '@/lib/config';

import { AddressService } from './address/service';
import { ChannelJSONConfigService } from './channelJson/service';
import { client } from './client/services';
import { CommerceToolsService } from './commerceTool/service';
import { UsersService } from './customerTypeIdentification/userServices';
import { JSONConfigService, StaticJsonConfigService } from './jsonConfigService/service';
import { MyAccountV2Service } from './myaccountV2/service';
import { OrderService } from './order/service';
import { PrequalService } from './prequal/service';
import { SentryService } from './sentry/service';
import { ServiceProviderService } from './serviceProvider/service';
import { TechnicianAvailabilityService } from './technicianAvailability/service';
import { VoiceService } from './voice/service';

export const ctService = new CommerceToolsService(ctAgent);
export const sentryService = new SentryService(SENTRY_DSN, APP_ENVIRONMENT, SENTRY_DENY_URLS);
export const addressService = new AddressService(addressAgent, client);
export const prequalService = new PrequalService(prequalAgent);
export const usersDetailService = new UsersService(usersDetailsAgent);
export const TechnicianDetailsAvailabilityService = new TechnicianAvailabilityService(
  technicianDetailsAgent
);
export const voiceService = new VoiceService(voiceAgent);
export const orderService = new OrderService(orderAgent);
export const configService = new JSONConfigService(agentJSONConfig);
export const serviceProviderService = new ServiceProviderService(serviceProviderAgent);

export const channelJSONConfigService = new ChannelJSONConfigService(channelJSONConfigAgent);
export const channelsJSONConfigService = new ChannelJSONConfigService(channelsJSONConfigAgent);
export const myAccountV2Service = new MyAccountV2Service(myAccountAgent, client);
export const staticJsonConfigService = new StaticJsonConfigService(staticJsonConfigAgent);
